import type { SelectedFileInterface } from '@sendpulse/file-manager';

import type { NormalizedBlockEntity, NormalizedColumnEntity } from '@web/types';
import type { Device } from '@sites/entity-core';

/** Entities the background-image pickers are shared between. */
export type BackgroundImageHost = NormalizedBlockEntity | NormalizedColumnEntity;

/**
 * Reads the picked background file off either host.
 *
 * Both entities keep it on the same responsive leaf now that the block has moved
 * to v0 as well, so this is one reader rather than the two it used to be.
 *
 * The schemas are deliberately lenient about a picked file (only `url` is
 * required); the runtime value is a full pick, hence the cast.
 */
export const backgroundImageOf = (entity: BackgroundImageHost, device: Device = 'desktop'): SelectedFileInterface => {
    const props = entity?.props as { background?: { image?: Record<string, unknown> } } | undefined;
    const image = props?.background?.image;

    // Every breakpoint falls back to desktop, the way each responsive reader does.
    return (image?.[device] ?? image?.desktop) as SelectedFileInterface;
};
